import type { User } from '../types/platform';

export const demoAccounts = [{ email: 'demo@nawat.ai', password: 'love2life' }];

export const demoProfiles: User[] = [
  {
    name: 'Sara Mansour',
    email: 'sara.mansour@nawat.ai',
    age: 31,
    location: 'Dubai, UAE',
    heightCm: 165,
    weightKg: 64,
    bloodType: 'A+',
    memberSince: 'Jun 2026',
    goal: 'pregnancy',
    stage: 'trimester-2',
  },
  {
    name: 'Leo Chen',
    email: 'leo.chen@nawat.ai',
    age: 39,
    location: 'Abu Dhabi, UAE',
    heightCm: 180,
    weightKg: 76,
    bloodType: 'O+',
    memberSince: 'Mar 2026',
    goal: 'longevity',
    stage: 'preconception',
  },
];
